import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router";
import "./LivePage.css";
import {
	Autocomplete,
	AutocompleteItem,
	Button,
	DateRangePicker,
	Pagination,
	Select,
	SelectItem,
	useDisclosure,
} from "@heroui/react";
import LiveStatisticCard from "../components/LiveStatisticCard";
import CommentForm from "../components/CommentForm";

const VerticalDotsIcon = ({ size = 24, width, height, ...props }) => {
	return (
		<svg
			aria-hidden="true"
			fill="none"
			focusable="false"
			height={size || height}
			role="presentation"
			viewBox="0 0 24 24"
			width={size || width}
			{...props}
		>
			<path
				d="M12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
				fill="currentColor"
			/>
		</svg>
	);
};

function LivePage(props) {
	const [dataSource, setDatasource] = useState([]);

	const [total, setTotal] = useState(0);

	const [selected, isSelected] = useState(false);

	const [name, setName] = useState(null);

	const [searchText, setSearchText] = useState("");

	const [order, setOrder] = useState("id");

	const host = location.hostname;

	const port = location.port;

	const protocol = location.protocol.replace(":", "");

	const [chart, setChart] = useState(false);
	const [chartId, setChartId] = useState(0);
	const [liver, setLiver] = useState(window.SEARCH_LIVER);

	const redirect = useNavigate();
	const refreshData = (page, size, name) => {
		var url =
			`${protocol}://${host}:${port}/api/live/list?page=` +
			page +
			"&limit=" +
			size;
		if (liver != null && liver !== "") {
			window.SEARCH_LIVER = liver;
			url = url + "&uid=" + (liver === -1 ? "0" : liver);
		} else {
			url = url + "&uid=0";
		}
		url = url + "&order=" + order;
		axios.get(url).then((res) => {
			res.data.lives.forEach((item, index) => {
				if (item.EndAt == 0) {
					res.data.lives[index].EndAt = "直播中";
				} else {
					res.data.lives[index].EndAt = new Date(
						item.EndAt * 1000,
					).toLocaleString();
				}
				res.data.lives[index].StartAt = new Date(
					item.StartAt * 1000 - 8 * 3600 * 1000,
				).toLocaleString();
				//res.data.lives[index].EndAt = new Date(item.EndAt * 1000).toLocaleString()
			});
			setTotal(res.data.totalPage * size);
			console.log(total);
			setDatasource(res.data.lives);
		});
	};

	useEffect(() => {
		refreshData(1, pageSize);
	}, []);

	const [filters, setFilters] = useState([]);

	const [currentPage, setCurrentPage] = useState(window.page ?? 1);

	const [pageSize, setPageSize] = useState(20);

	// 处理页码改变事件
	const handlePageChange = (page, pageSize) => {
		console.log(`page=${page}  pageSize=${pageSize}`);
		refreshData(page, pageSize, name);
		setCurrentPage(page);
		setPageSize(pageSize);
		window.page = page;
	};

	useEffect(() => {
		refreshData(currentPage, pageSize);
	}, [liver, order]);
	useEffect(() => {
		if (chartId !== null && chartId !== 0) {
			setChart(true);
		}
	}, [chartId]); // 监听 chartId 变化后再设置 chart

	return (
		<div className={""}>
			<div className="sm:flex-row flex mb-4 flex-col">
				<Autocomplete
					className="max-w-xs mt-4 mb-4 ml-4"
					items={filters}
					isClearable
					defaultInputValue={window.LIVER_NAME ?? ""}
					label="Liver"
					onSelectionChange={(e) => {
						setCurrentPage(1);

						filters.forEach((filter) => {
							if (filter.UserID === parseInt(e)) {
								setLiver(filter.UserID);
								window.LIVER_NAME = filter.UName;
							}
						});
						console.log("onSelectionChange");
					}}
					onInputChange={(e) => {
						axios.get(`/api/searchLiver?key=` + e).then((res) => {
							if (!res.data.result) return;
							setFilters(res.data.result);
						});
					}}
					onClear={() => {
						window.SEARCH_LIVER = "";
						setLiver(-1);
					}}
				>
					{(f) => (
						<AutocompleteItem key={f.UserID}>
							{f.UserName}
						</AutocompleteItem>
					)}
				</Autocomplete>
				<Select
					isClearable
					className="max-w-xs mt-4 mb-4 ml-4"
					items={[
						{
							key: "Time",
							value: "Time",
						},
						{
							key: "money",
							value: "Money",
						},
						{
							key: "message",
							value: "Message",
						},
						{
							key: "watch",
							value: "Watched",
						},
					]}
					label="Sort by"
					onSelectionChange={(e) => {
						setOrder(e.currentKey);
					}}
				>
					{(f) => <SelectItem key={f.key}>{f.value}</SelectItem>}
				</Select>
				{/*               <DateRangePicker
                    className="max-w-xs mt-4 mb-4 ml-4"
                    label="Stay duration" />;*/}
			</div>

			<div
				className={
					"grid grid-cols-1 md:grid-cols-4 2xl:grid-cols-5 gap-4"
				}
			>
				{dataSource.map((item) => {
					return (
						<LiveStatisticCard
							item={item}
							showUser
							allowClick={true}
						/>
					);
				})}
			</div>
			<Pagination
				isCompact
				showControls
				showShadow
				color="secondary"
				page={currentPage}
				total={total / pageSize}
				initialPage={1}
				onChange={(page) => handlePageChange(page, pageSize)}
				classNames={{
					wrapper: "w-full mx-4",
				}}
			/>
		</div>
	);
}

export default LivePage;
